import { CaptionLanguages } from 'GeminiViewerComponent/helpers';

const VideoCaptions = ({ contentURL, captionLanguages }) => {
    if (!captionLanguages || captionLanguages.length === 0) {
        return null;
    }

    return captionLanguages.map((caption, index) => {
        const captionLanguage = Object.values(CaptionLanguages)?.find((lang) => lang.LanguageCode === caption);

        if (!captionLanguage) {
            return null;
        }

        return (
            <track
                key={`caption-${index}`}
                label={captionLanguage.DisplayName}
                kind="subtitles"
                srcLang={captionLanguage.LanguageCode}
                src={`${contentURL}_${captionLanguage.LanguageCode}.vtt`}
                default={index === 0}
            />
        );
    });
};

export { VideoCaptions };
